import React, { useCallback, useEffect } from "react";
import { Button, Modal } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useInactivityTimeout } from "../../custom-hooks/useInactivityTimeout";
import {
  beginLogoutOnce,
  clearAuthSession,
  getPartnerLoginPath,
  resetLogoutGuard,
} from "../../utils/authSession";
import { formatWarningCountdown } from "../../utils/inactivityTimeout";
import "./SessionTimeout.scss";

const SessionTimeout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    resetLogoutGuard();
  }, []);

  const handleLogout = useCallback(
    (reason) => {
      if (!beginLogoutOnce()) {
        return;
      }
      if (reason === "cross-tab") {
        navigate(getPartnerLoginPath());
        return;
      }
      const loginPath = clearAuthSession({
        inactivityLogout: reason === "timeout",
      });
      navigate(loginPath);
    },
    [navigate]
  );

  const {
    isWarningVisible,
    warningRemainingMs,
    handleStayLoggedIn,
    handleInactivityLogout,
  } = useInactivityTimeout({
    enabled: true,
    onLogout: handleLogout,
  });

  return (
    <Modal
      className="session-timeout-modal confirmation-modal"
      title={null}
      visible={isWarningVisible}
      closable={false}
      maskClosable={false}
      keyboard={false}
      centered
      footer={null}
      width={440}
      destroyOnClose
    >
      <div className="session-timeout-content">
        <div className="session-timeout-icon" aria-hidden="true">
          <ClockCircleOutlined />
        </div>
        <h2 className="session-timeout-title">Session Timeout</h2>
        <p className="session-timeout-message">
          You have been inactive for a while. Would you like to stay logged in?
        </p>
        <div className="session-timeout-countdown" role="status" aria-live="polite">
          {formatWarningCountdown(warningRemainingMs)}
        </div>
        <div className="modalBtns session-timeout-actions">
          <Button
            className="cancel-btn"
            onClick={handleInactivityLogout}
          >
            Log Out
          </Button>
          <Button
            className="confirm-btn"
            type="primary"
            onClick={handleStayLoggedIn}
          >
            Stay Logged In
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default SessionTimeout;
